import axios, { AxiosResponse, AxiosError } from "axios";
import { CustomerInfoDto, CustomerValidationResponse } from "../types/customer";
import { CustomerPreferences } from "../types/customer";
import { handleApiError } from "../../common/api/apiErrorHandler";

export default class CustomersApi {
  static validateCustomer(info: CustomerInfoDto): Promise<CustomerValidationResponse> {
    return axios
      .post(`/api/customers/ValidateCustomer`, info)
      .then((response: AxiosResponse<CustomerValidationResponse>) => {
        return response.data;
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          throw error.response.data;
        } else {
          throw new Error("Unable to verify user");
        }
      });
  }

  static async getCustomerPreferences(customerId: number): Promise<CustomerPreferences> {
    try {
      const response = await axios.get<CustomerPreferences>(`/api/customers/${customerId}/Preferences`);
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }

  static async patchCustomerPreferences(customerPreferences: CustomerPreferences): Promise<CustomerPreferences> {
    try {
      const response = await axios.patch<CustomerPreferences>(
        `/api/customers/${customerPreferences.customerId}/Preferences`,
        {
          ...customerPreferences
        }
      );
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }
}
